import { Column, Entity, OneToMany } from 'typeorm';
import { serialize } from '../helper';
import Pergunta from './Pergunta';
import PerguntaBase from './PerguntaBase';
import RespostaNoPedido from './RespostaNoPedido';

@Entity()
export class PerguntaNoPedido extends PerguntaBase {
  @Column()
  perguntaId: number = 0;

  @OneToMany(() => RespostaNoPedido, (resposta: RespostaNoPedido) => resposta.perguntaNoPedido, {
    eager: true,
    cascade: true
  })
  respostasNoPedido!: RespostaNoPedido[];
}

export default PerguntaNoPedido;

export const criarPerguntaNoPedido = (pergunta: Pergunta) => {
  const copia = { ...pergunta };
  const perguntaNoPedido = new PerguntaNoPedido();
  delete copia.respostas;
  delete copia.id;
  Object.assign(perguntaNoPedido, copia);
  perguntaNoPedido.perguntaId = pergunta.id;
  perguntaNoPedido.respostasNoPedido = [];
  return serialize<PerguntaNoPedido>(perguntaNoPedido);
};

export const criarListaPerguntasNoPedido = (perguntas?: Pergunta[]) => {
  if (!perguntas) {
    return [];
  }
  const retorno = perguntas.map((pergunta) => criarPerguntaNoPedido(pergunta));
  return retorno;
};
